import React from "react";
import Slider from "../../UI/Slider";
import KioskHomeBannerSkeleton from "./skeleton/KioskHomeBannerSkeleton";
import placeholder600x440 from "assets/placeholder/600x440.png";

const KioskHomeBanner = ({ banners, loading }) => {
  if (!banners || loading) {
    return <KioskHomeBannerSkeleton />;
  }

  return (
    <Slider settings={{pagination: false}} >
      {banners.map((banner, i) => {
        return (
          <div key={i}>
            <img src={banner.url || placeholder600x440} alt="banner" className="img-fluid" style={{height: 222}}/>
          </div>
        );
      })}
    </Slider>
  );
};

export default KioskHomeBanner;
